import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { progressionApi } from '../api/progression';
import { QUERY_KEYS } from '../utils/constants';

export function useBelts() {
  return useQuery({
    queryKey: [QUERY_KEYS.belts],
    queryFn: progressionApi.getBelts,
    staleTime: 60 * 60 * 1000,
  });
}

export function useAthleteProgression(athleteId: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.progression, athleteId],
    queryFn: () => progressionApi.getAthleteProgression(athleteId),
    enabled: !!athleteId,
  });
}

export function useDeclareSelfRank() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: progressionApi.declareSelfRank,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.progression] });
    },
  });
}

export function useCreatePromotion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: progressionApi.createPromotion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.progression] });
    },
  });
}
